// Pure project-model helpers for the Dashboard (Brief 4 / P8). No React, no I/O
// — just name resolution and the create-form validation, so the sidebar and the
// sessions header read consistently and the form gives instant feedback that
// MATCHES the backend's own rules (trim + non-empty + <= MAX_PROJECT_NAME).

import type { ProjectSummary } from "@waytide/core";
import { UNASSIGNED_PROJECT_ID } from "@waytide/ui";

/** The label for the bucket of sessions with no project. */
export const UNASSIGNED_LABEL = "Unassigned";

/** Mirror of the backend `MAX_PROJECT_NAME` (project_routes) so client-side
 * validation matches the server exactly. */
export const MAX_PROJECT_NAME = 120;

/** A project id's display name: its real name, the Unassigned label for the
 * 0 bucket, or a stable fallback if the list hasn't loaded the id yet. */
export function projectName(
  projects: ProjectSummary[],
  projectId: number,
): string {
  if (projectId === UNASSIGNED_PROJECT_ID) return UNASSIGNED_LABEL;
  return (
    projects.find((p) => p.project_id === projectId)?.name ??
    `Project #${projectId}`
  );
}

/** "" when a typed project name is valid; otherwise a plain reason. Same
 * trim/length rules the backend enforces, so the form never lets through a name
 * the server will reject. */
export function projectNameError(raw: string): string {
  const name = raw.trim();
  if (!name) return "A project needs a name.";
  if ([...name].length > MAX_PROJECT_NAME) return "That name is too long.";
  return "";
}
